// extracted by mini-css-extract-plugin
export default {"app":"styles_app_Nx_Pn","map":"styles_map_aEfgj"};